<xt-ui-kit-dialog *transloco="let t" [config]="dialogConfig">
</xt-ui-kit-dialog>
